import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Resources.css";


const Resources = () => {
  const [showWorkshops, setShowWorkshops] = useState(false);
  const [showArticles, setShowArticles] = useState(false);
  const [showImage, setShowImage] = useState(true);


  const toggleWorkshops = () => {
    if (showWorkshops) {
      setShowImage(true);
    } else {
      setShowImage(false);
    }
    setShowWorkshops(!showWorkshops);
    setShowArticles(false);
  };


  const toggleArticles = () => {
    if (showArticles) {
      setShowImage(true);
    } else {
      setShowImage(false);
    }
    setShowArticles(!showArticles);
    setShowWorkshops(false);
  };


  return (
    <div className="container">
      <header>
        <h1 className="title">Mental Health Resources for Construction Workers</h1>
      </header>
      <section className="resourceList">
      <Link to="https://www.letsbuild.com/blog/top-construction-forums" className="resourceItem">
        <div>
          <h2 className="resourceTitle">Support Groups</h2>
          <p className="resourceDescription">
            Join online communities where you can connect with fellow construction workers facing similar challenges.
          </p>
        </div>
      </Link>
        <Link to="/contact" className="resourceItem">
          <div>
            <h2 className="resourceTitle">Counseling Services</h2>
            <p className="resourceDescription">
              Access professional counseling services that understand the unique stressors of the construction industry.
            </p>
          </div>
        </Link>
        <div className="resourceItem" onClick={toggleWorkshops}>
          <h2 className="resourceTitle">Stress Management</h2>
          <p className="resourceDescription">
            Participate in workshops and courses focused on managing stress and improving mental well-being.
          </p>
        </div>
        <div className="resourceItem" onClick={toggleArticles}>
          <h2 className="resourceTitle">Articles and Videos</h2>
          <p className="resourceDescription">
            Explore a collection of articles and guides on mental health and coping strategies for construction workers.
          </p>
        </div>
      </section>
      {showWorkshops && (
        <div className="relevantLinks">
          <div className="leftColumn">
            <h3>Workshops:</h3>
            <ul className="workshopsList">
            <li>
                <a href="https://pll.harvard.edu/course/stress-management">Online Stress Management Workshop</a>
              </li>
              <li>
                <a href="https://www.open.edu/openlearn/money-business/effective-communication-the-workplace/content-section-overview?active-tab=description-tab">Effective Communication Training</a>
              </li>
              <li>
                <a href="https://whatfix.com/blog/resilience-training/#:~:text=Resilience%20training%20in%20the%20workplace%20often%20focuses%20on%20developing%20skills,of%20what%20one%20can%20control.">Building Resilience in Construction</a>
              </li>
              <li>
                <a href="https://professionaldevelopmenttraining.com/courses/work-life-balance-training-in-atlanta-baltimore-boston-charlotte-chicago-los-angeles-new-york-miami-orlando-philadelphia-seattle-and-us-wide">Work-Life Balance Seminar</a>
              </li>
            </ul>
          </div>
        </div>
      )}
      {showArticles && (
        <div className="relevantLinks">
          <div className="leftColumn">
            <h3>Articles:</h3>
            <ul>
            <li>
                <a href="https://www.procore.com/library/mental-health-construction#:~:text=for%20construction%20workers-,Mental%20health%20in%20construction%20by%20the%20numbers,on%20symptoms%20or%20medication%20use.">Procore</a>
              </li>
              <li>
                <a href="https://medlineplus.gov/howtoimprovementalhealth.html">Mental Health Tips!</a>
              </li>
              <li>
                <a href="https://www.apa.org/news/apa/2022/surgeon-general-workplace-well-being">Priority of Mental Health</a>
              </li>
            </ul>
          </div>
          <div className="rightColumn">
            <h3>Videos:</h3>
            <ul>
            <li>
                <a href="https://www.youtube.com/watch?v=07uILJp0cRY&pp=ygUabWVudGFsIGhlYWx0aCBjb25zdHJ1Y3Rpb24%3D">Building Better Mental Health</a>
              </li>
              <li>
                <a href="https://www.youtube.com/watch?v=SQtwuOQvS9U&pp=ygUabWVudGFsIGhlYWx0aCBjb25zdHJ1Y3Rpb24%3D">Mental Health Awareness in Construction</a>
              </li>
              <li>
                <a href="https://www.youtube.com/watch?v=3QIfkeA6HBY&pp=ygUjc3RyYXRlZ2llcyB0byBpbXByb3ZlIG1lbnRhbCBoZWFsdGg%3D">Mental Health Tips!</a>
              </li>
            </ul>
          </div>
        </div>
      )}
       <div className="imageContainer" style={{ display: showImage ? "block" : "none" }}>
        <img src="https://intranet.ade.arkansas.gov/App_Files/img/Appreciation.png" alt="Appreciation" className="appreciationImage" />
      </div>
    </div>
  );
};


export default Resources;